'use server';

import { NON_STRUCTURED_SECTION } from '../../api/endpoints';
import request from '../../api/request';
import { actionKitImpFunction } from '../../components/ozmoit/common/action-kit-imp';
import {
  CourseListResponseType,
  FormDataResponseType,
} from '../../types/sectionMaintainerTypes';

export const getNonStructuredFormDataAction = actionKitImpFunction(async () => {
  const response = await request<FormDataResponseType>(
    NON_STRUCTURED_SECTION.GET_CREATE,
  );

  if (response.error) {
    throw new Error(response.error.error.message || 'Error loading form data');
  }

  return response.data;
});

export const getNonStructuredCoursesAction = actionKitImpFunction(
  async ({ schoolId }: { schoolId?: number } = {}) => {
    const faculty = schoolId ? `?schoolId=${schoolId}` : '';
    const response = await request<CourseListResponseType>(
      NON_STRUCTURED_SECTION.COURSES_LIST + faculty,
    );

    if (response.error) {
      throw new Error(response.error.error.message || 'Error loading courses');
    }

    return response.data;
  },
);
